module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_1.5b186c7b.png";